import Masterpass from './Masterpass';

export default Masterpass;
